import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M10.0003 1.66666C5.39795 1.66666 1.66699 5.39762 1.66699 9.99999C1.66699 14.6024 5.39795 18.3333 10.0003 18.3333C14.6027 18.3333 18.3337 14.6024 18.3337 9.99999C18.3337 5.39762 14.6027 1.66666 10.0003 1.66666ZM10.0003 7.49999C9.68589 7.49999 9.41085 7.67382 9.26823 7.93459C9.04737 8.33837 8.541 8.48667 8.13722 8.26581C7.73343 8.04496 7.58514 7.53859 7.80599 7.13481C8.22919 6.36108 9.05253 5.83332 10.0003 5.83332C11.2626 5.83332 12.1394 6.67201 12.389 7.65749C12.64 8.6482 12.2587 9.80249 11.1184 10.3727C10.9439 10.4599 10.8337 10.6382 10.8337 10.8333C10.8337 11.2936 10.4606 11.6667 10.0003 11.6667C9.5401 11.6667 9.167 11.2936 9.167 10.8333C9.167 10.007 9.63389 9.25152 10.373 8.88196C10.752 8.69248 10.8493 8.36644 10.7734 8.06674C10.6961 7.7618 10.4406 7.49999 10.0003 7.49999ZM10.0003 14.1667C10.4606 14.1667 10.8337 13.7936 10.8337 13.3333C10.8337 12.8731 10.4606 12.5 10.0003 12.5C9.54009 12.5 9.16699 12.8731 9.16699 13.3333C9.16699 13.7936 9.54009 14.1667 10.0003 14.1667Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }